import { render, staticRenderFns } from "./TotalEarnedPointsRedaction.vue?vue&type=template&id=14ff333c&scoped=true&"
import script from "./TotalEarnedPointsRedaction.vue?vue&type=script&lang=js&"
export * from "./TotalEarnedPointsRedaction.vue?vue&type=script&lang=js&"
import style0 from "./TotalEarnedPointsRedaction.vue?vue&type=style&index=0&id=14ff333c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ff333c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
